import { GlobalAxios } from "../axios/axios-config";
import { ITasyInsuranceType } from "../models/tasy-insuranceType";

const INSURANCE_TYPE_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/DomainValue/DomainValue";

export const getInsuranceTypesList = (params?: any) => {
  return GlobalAxios.get<ITasyInsuranceType[]>(INSURANCE_TYPE_ROUTE, {
    params
  });
};